import React from 'react'
import classes from "./Scheduler.module.css"
import Title from "../../Components/Websites/Title"

const Sheduler = () => {
    return (
        <div>
            <Title
                heading1="PhotoBiz Scheduler"
                heading2="LET CLIENTS BOOK APPOINTMENTS"
            />
        </div>
    )
}

export default Sheduler
